import React, { Component } from "react"
import { Toast } from "@shopify/app-bridge-react"
import axios from "../../funcs/axios"
import { Card, DataTable, Button, Page, Icon } from "@shopify/polaris"
import { DeleteMinor } from "@shopify/polaris-icons"
import "./style.scss"
export default class CouponsManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: null,
            toast: {
                error: false,
                content: "",
                show: false,
            },
        }
        this.loadCoupons()
    }

    handleDeleteCoupons = (index) => {
        const { data } = this.state
        let code = data[index].code
        data.splice(index, 1)
        this.setState({ data })
        axios
            .delete(`${window.SHOPIFY_APP_HOST}/admin/delete-coupons/` + code)
            .then((res) => {
                this.setState({
                    toast: { show: true, content: res.data.msg, error: false },
                })
            })
            .catch((err) => console.log(err))
    }

    loadCoupons = () => {
        axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/get-coupons`)
            .then((res) => {
                this.setState({ data: res.data.trial })
                this.setState({
                    toast: { show: true, content: res.data.msg, error: false },
                })
            })
            .catch((err) => console.log(err))
    }

    loadTable = () => {
        const { data } = this.state
        let rows = []
        if (data) {
            for (let i = 0; i < data.length; i++) {
                let dataRows = []
                dataRows.push(i + 1)
                dataRows.push(data[i].code)
                dataRows.push(data[i].description)
                dataRows.push(data[i].trial_days)
                let specificStore = " - "
                let storeUsed = " - "
                if (data[i].specific_store) {
                    console.log('specific_store', data[i].specific_store)
                    let array = data[i].specific_store.split(",")
                    specificStore = array.map((_item, index) => {
                        return <p key={index}>{_item.trim()}</p>
                    })
                }
                if (data[i].stores_used) {
                    let store = JSON.parse(data[i].stores_used)
                    storeUsed = store.map((_item, index) => {
                        return <p key={index}>{_item}</p>
                    })
                }
                dataRows.push(<div>{specificStore}</div>)
                dataRows.push(<div>{storeUsed}</div>)
                dataRows.push(
                    <Button
                        icon={<Icon source={DeleteMinor} />}
                        onClick={() => this.handleDeleteCoupons(i)}
                        size="slim"
                    ></Button>,
                )
                rows.push(dataRows)
            }
        }
        return rows
    }

    render() {
        const { toast } = this.state
        let rows = this.loadTable()
        return (
            <div className="coupons-management">
                <Page title="Create coupons">
                    <DataTable
                        columnContentTypes={["numeric", "text", "text", "text", "text", "text"]}
                        headings={[
                            "#",
                            "Code",
                            "Description",
                            "Trial days",
                            "Specific Store",
                            "Store used",
                            "Actions",
                        ]}
                        rows={rows}
                    />

                    {toast.show && (
                        <Toast
                            content={toast.content}
                            error={toast.error}
                            onDismiss={() =>
                                this.setState({
                                    toast: { show: false, content: "", error: false },
                                })
                            }
                        />
                    )}
                </Page>
            </div>
        )
    }
}
